import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IFetchScheduleInterviewAction,
    IScheduleInterviewData,
    ISetScheduleInterviewDataAction,
    ISubmitScheduleInterviewAction,
} from './interface';

interface IScheduleInterviewSlice {
    data: IScheduleInterviewData | null;
    error: string | null;
    uiState: {
        isFetchLoading: boolean;
        isSubmitLoading: boolean;
    };
}

const initialState: IScheduleInterviewSlice = {
    data: null,
    error: null,
    uiState: {
        isFetchLoading: false,
        isSubmitLoading: false,
    },
};

export const sliceName = 'scheduleInterview';
export const scheduleInterviewSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        fetchScheduleInterview: (
            state,
            _action: PayloadAction<IFetchScheduleInterviewAction>
        ) => {
            state.uiState.isFetchLoading = true;
            state.error = null;
        },
        setScheduleInterviewData: (
            state,
            action: PayloadAction<ISetScheduleInterviewDataAction>
        ) => {
            state.data = action.payload.data;
            state.uiState.isFetchLoading = false;
        },
        setScheduleInterviewError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.uiState.isFetchLoading = false;
        },
        submitScheduleInterview: (
            state,
            _action: PayloadAction<ISubmitScheduleInterviewAction>
        ) => {
            state.uiState.isSubmitLoading = true;
        },
        setSubmitScheduleInterviewDone: (state) => {
            state.uiState.isSubmitLoading = false;
        },
        clearScheduleInterview: (state) => {
            state.data = null;
            state.error = null;
            state.uiState.isFetchLoading = false;
            state.uiState.isSubmitLoading = false;
        },
    },
});

export const scheduleInterviewActions = scheduleInterviewSlice.actions;
export default scheduleInterviewSlice.reducer;
